import { transparencyColors } from '@Components/BigBrowse/GridCardMesh/gridCardConstants';
import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { MultiSectionHeroText } from '@Components/BigBrowse/bb2/meshes2/cards/MultiSectionHeroText';
import { VideoPlane } from '@Components/BigBrowse/bb2/meshes2/cards/VideoPlane';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';

import type { GridCardMeshProps } from '../GridCardMesh2';
import { ProductCardRounded } from '../primitives/ProductCardRounded';

export const MultiSectionHero = observer(function MultiSectionHero({
  item,
  onClick,
}: GridCardMeshProps<PlaneTypes.Card_MultiSection_Hero>) {
  const x = item.worldPosition.x + (item.data?.dx ?? 0);
  const position = { x, y: item.worldPosition.y };

  const videoData = useMemo(
    () =>
      item.data?.dataModel.header.heroMedia.items.find(
        (i) => i.mediaType === 'Mp4VideoClip'
      ),
    [item]
  );

  const imageData = useMemo(
    () =>
      item.data?.dataModel.header.heroMedia.items.find(
        (i) => i.mediaType === 'Image'
      ),
    [item]
  );

  const hasVideo = videoData !== undefined;

  if (hasVideo) {
    return (
      <VideoPlane
        position={position}
        size={item.size}
        src={videoData.url}
        radius={15}
        sourceSize={{ width: videoData.width, height: videoData.height }}
      />
    );
  }

  return (
    <ProductCardRounded
      position={position}
      size={item.size.width}
      imageUrl={imageData?.url}
      transparencyColor={transparencyColors[item.type]}
      hoverDisabled
      onClick={onClick}
      uniqueKey={item.key!}
      isViewHero={item.data?.isViewHero}
    >
      <MultiSectionHeroText
        gridCard={item as GridCard<PlaneTypes.Card_MultiSection_Hero>}
      />
    </ProductCardRounded>
  );
});
